import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Doughnut } from "react-chartjs-2";

class AgorasVolume extends Component {
  render() {
    const data = {
      labels: ["CoinbasePro", "Binance", "Kraken", "HitBTC", "Bitfinex"],
      datasets: [
        {
          data: [13.4, 10.3, 3.74, 1.14, 6.78],
          borderColor: ["#29ccd7", "#6892ff", "#77d760", "#e8d73b", "#ff7777"],
          backgroundColor: [
            "#29ccd7",
            "#6892ff",
            "#77d760",
            "#e8d73b",
            "#ff7777"
          ],
          borderWidth: 1
        }
      ]
    };

    const doughnutOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      }
    };

    return (
      <div className="col-lg-4 col-md-6 p-3 home-market-stat-col">
        <div
          className="market-column h-100 p-3"
          style={{
            background: "var(--cardBg)",
            border: "var(--card-border)"
          }}
        >
          <div className="row">
            <div className="col-12">
              <div className="market-inner-col d-flex justify-content-between mb-3">
                <span className="badge badge-warning market-bedge">
                  Agoras Volume Stats
                </span>
                <img
                  className="img-fluid"
                  src={require("../../../assets/icons/share-icon.svg")}
                  alt="share"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <h3
                className="market-col-heading text-left volume-stats-head"
                style={{ color: "var(--h3Color)" }}
              >
                Volume Stats
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12 market-inner-col d-flex justify-content-between mt-3 mb-3 sector-category">
              <span
                className="currency-row"
                style={{ color: "var(--pDescColor)" }}
              >
                Sector : <span className="currency-text">Stats</span>
              </span>
              <span
                className="currency-row"
                style={{ color: "var(--pDescColor)" }}
              >
                Category : <span className="currency-text">Currency</span>
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-12 stats-div mt-4">
              <p style={{ color: "var(--pDescColor)" }}>
                24h Volume by Currency
              </p>

              <div className="row stat-graphs-wrap mt-4">
                <div className="col-2 text-center">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar usd-bar"
                      style={{ height: "90%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    USD
                    <br />
                    <span>13.7</span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>

                <div className="col-2 mt-auto">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar btc-bar"
                      style={{ height: "30%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    BTC
                    <br />
                    <span>9.91</span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>

                <div className="col-2 mt-auto">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar usdt-bar"
                      style={{ height: "30%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    USDT
                    <br />
                    <span>4.61 </span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>

                <div className="col-2 mt-auto">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar eur-bar"
                      style={{ height: "30%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    EUR
                    <br />
                    <span>636</span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>

                <div className="col-2 mt-auto">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar eth-bar"
                      style={{ height: "30%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    ETH
                    <br />
                    <span>202</span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>

                <div className="col-2 mt-auto">
                  <div className="progress progress-bar-vertical">
                    <div
                      className="progress-bar bnb-bar"
                      style={{ height: "30%" }}
                    />
                  </div>

                  <h3 style={{ color: "var(--h3Color)" }}>
                    BNB
                    <br />
                    <span>163</span>
                    <br />
                    <span>Magrs</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 stats-div mt-4">
              <p className="mb-3" style={{ color: "var(--h3Color)" }}>
                24h Volume by Exchange
              </p>
            </div>
          </div>

          <div className="d-flex float-left exchange-stat-wrap ">
            <div className="col-5 p-1">
              <Doughnut data={data} options={doughnutOptions} />
            </div>
            <div className="p-1">
              <ul className="exchange-stat-points">
                <li style={{ color: "var(--listColor)" }}>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="faCircle exchange-icon-1"
                  />{" "}
                  CoinbasePro <span>13.4 Magrs</span>
                </li>
                <li className="" style={{ color: "var(--listColor)" }}>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="faCircle exchange-icon-2"
                  />{" "}
                  Binance<span>10.3 Magrs</span>
                </li>
                <li className="" style={{ color: "var(--listColor)" }}>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="faCircle exchange-icon-3"
                  />{" "}
                  Kraken<span> 3.74 Magrs </span>
                </li>
                <li className="" style={{ color: "var(--listColor)" }}>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="faCircle exchange-icon-4"
                  />{" "}
                  HitBTC<span>1.14 Magrs</span>
                </li>
                <li className="" style={{ color: "var(--listColor)" }}>
                  <FontAwesomeIcon
                    icon={faCircle}
                    className="faCircle exchange-icon-5"
                  />{" "}
                  Bitfinex<span>678 Kagrs </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AgorasVolume;
